<a
  *ngIf="(supported$ | async) && (entity.externalId || entity.externalDisplayId)"
  mat-mini-fab
  target="_blank"
  rel="noopener noreferrer"
  [ngClass]="{'social-mini': mini, 'social': !mini}"
  [class]="getAts$ | async"
  [href]="externalUrl$ | async"
  data-cy="ats-button"
>

  <mat-icon
    [ngClass]="{'custom-mini': mini}"
    [svgIcon]="getAts$ | async"
  ></mat-icon>
</a>
